
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange, OnFocus, OnInput, OnKeyUp } from "../../../library-js/dom-tools/EventListeners";
import { InspectorField } from "./InspectorField";
import { Loma } from "../../../library-js/rj/parsers/Loma/Loma";
import { InputFieldElement } from "./InputFieldElement";


export class NumberField extends InspectorField<number>
{
  static readonly type = new ElementType( "number--field" );

  protected _inputField:HTMLInputElement;
  protected _expressionValue:string;
  protected _computedValue:string;

  createElement() 
  {
    let element = NumberField.type.create();
    InspectorField.flag.set( element );

    let inputField = ElementType.input.create();

    let ife = InputFieldElement.get( inputField );

    this._inputField = inputField;
    AttributeValue.type_text.set( inputField );

    element.appendChild( inputField );

    ife._expressionValue = "";
    ife._computedValue = "";

    OnKeyUp.add( inputField, 
      ( e )=>
      {
        console.log( "E is ", e );
        if ( ( e as any ).key === "Enter" )
        {
          inputField.blur();
        }

        
      }
    );

    OnChange.add( inputField,
      ()=>
      {
        let textValue = inputField.value;
        let isNumber = /^\d*(\.|\,)?\d+$/.test( textValue );


        let value = 0;
        console.log( "OnChange:", textValue, isNumber );

        if ( ! isNumber )
        {
          textValue = textValue.replace( /\,/g, "." );

          let lomaValue = Loma.compute( textValue );
          console.log( "Number Field:",  textValue, ">>", lomaValue );

          if ( isNaN( lomaValue ) )
          {
            value = 0;
            inputField.value = "0";

            ife._computedValue = "0";
            ife._expressionValue = "0";

            this._computedValue = "0";
            this._expressionValue = "0";
          }
          else
          {
            ife._computedValue = lomaValue;
            ife._expressionValue = textValue;
            this._expressionValue = ife._expressionValue;
            this._computedValue   = ife._computedValue;

            let inputFieldValue = ife._computedValue;
            value = lomaValue;
            inputField.value = inputFieldValue;

            console.log( "setting value:", inputFieldValue, inputField.value );

            
          }          
          
        }
        else
        {
          value = parseFloat( inputField.value );
          ife._computedValue = value + "";
          ife._expressionValue = ife._computedValue +"";
          this._expressionValue = ife._expressionValue;
          this._computedValue = ife._computedValue;
        }
        
        
        if ( this.value === value )
        {
          return;
        }

        this._value = value;

        console.log( "Setting value to", value );

        this.onChange.dispatch( this.value );        

       

      }
    );

    this._element = element;
  }

  set value( t:number )
  { 
    if ( this._computedValue === t + "" )
    {
      console.log( "Not setting value again:", t, this._computedValue, this._expressionValue );
      return;
    }

    this._expressionValue = t + "";
    this._computedValue = t + "";

    this._value = t;

    this.syncValueToElement();

    console.log( "Setting value to", this._value );
  }

  get value()
  {
    return this._value;
  }

  syncValueToElement()
  {
    if ( this._expressionValue === this._computedValue )
    {
      console.log( "setting number value", this._expressionValue, this._computedValue );
      this._inputField.value = `${this._computedValue}`;
    }
    else
    {
      console.log( "setting expression value", this._expressionValue, this._computedValue );
      this._inputField.value = `${this._expressionValue}=${this._computedValue}`;
    }
    

    
  }
  
  
}